/**
 * Copyright (c) samjay.dev.
 *
 * Notes:
 * This source code is the private property of samjay.dev.
 * You cannot modify, share or copy these source codes without any formal authorization,
 * otherwise samjay.dev reserves the right to pursue any legal action.
 *
 * Developer: Sam Tsang (info@samjay.dev)
 */

import React from 'react';
import { InView } from 'react-intersection-observer';
import { getSvgIcon } from 'resources';
import AppStyle from 'scss/main/App.module.scss';
import { useSelector } from 'react-redux';
import { RootState } from 'store/types';

const Contact: React.FC<{}> = () => {

  return (
    <div className={AppStyle["contact"]}>
      <div>
        <div>
          <div>
            <InView triggerOnce>
              {({ inView, ref, entry }) => (
                <div className={`${inView && AppStyle['descAnimA']}`} style={{ opacity: !inView ? '0.0' : '1.0' }} ref={ref} >
                  <div>Let’s work</div>
                  <div>together</div>
                </div>
              )}
            </InView>
            <InView triggerOnce>
              {({ inView, ref, entry }) => (
                <div className={`${inView && AppStyle['descAnimA']}`} style={{ opacity: !inView ? '0.0' : '1.0' }} ref={ref} >
                  <div>Let’s work together</div>
                </div>
              )}
            </InView>
            <InView triggerOnce>
              {({ inView, ref, entry }) => (
                <div className={`${inView && AppStyle['descAnimI']}`} style={{ opacity: !inView ? '0.0' : '1.0' }} ref={ref} >
                  <div>
                    Based Location
                  </div>
                  <div>
                    Hong Kong
                  </div>
                </div>
              )}
            </InView>
            <div>
              <InView triggerOnce>
                {({ inView, ref, entry }) => (
                  <div className={`${inView && AppStyle['descAnimI']}`} style={{ opacity: !inView ? '0.0' : '1.0' }} ref={ref} >
                    <div dangerouslySetInnerHTML={{ __html: `${getSvgIcon({ name: 'github' })}` }} onClick={() => {
                    window.open("https://github.com/samjayhk", "_blank");
                  }} />
                  <div dangerouslySetInnerHTML={{ __html: `${getSvgIcon({ name: 'linkedin' })}` }} onClick={() => {
                    window.open("https://www.linkedin.com/in/samjayts", "_blank");
                  }} />
                  <div dangerouslySetInnerHTML={{ __html: `${getSvgIcon({ name: 'teams' })}` }} onClick={() => {
                    window.open("https://teams.live.com/l/invite/FEA8kBtLW4S4Nj53QE", "_blank");
                  }} />
                  <div dangerouslySetInnerHTML={{ __html: `${getSvgIcon({ name: 'whatsapp' })}` }} onClick={() => {
                    window.open("https://api.whatsapp.com/send?phone=85290107715", "_blank");
                  }} />
                  <div dangerouslySetInnerHTML={{ __html: `${getSvgIcon({ name: 'tg' })}` }} onClick={() => {
                    window.open("https://telegram.me/samjayts", "_blank");
                  }} />
                    </div>
                  )}
              </InView>
            </div>
          </div>
        </div>
        <div>
          <div>
            <InView triggerOnce>
              {({ inView, ref, entry }) => (
                <div className={`${inView && AppStyle['descAnimI']}`} style={{ opacity: !inView ? '0.0' : '1.0' }} ref={ref} >
                  <div>
                    Contact
                  </div>
                  <div>
                    <div>info@samjay.dev</div>
                    <div>(+852) 9010-7715</div>
                    <div>(+44) 7510-599-459</div>
                    <div>(+1) 778-775-5548</div>
                  </div>
                </div>
              )}
            </InView>
            <InView triggerOnce>
              {({ inView, ref, entry }) => (
                <div className={`${inView && AppStyle['descAnimI']}`} style={{ opacity: !inView ? '0.0' : '1.0' }} ref={ref} >
                  <div>
                    Current Interested Position
                  </div>
                  <div>
                    <div>#Full Stack Engineer</div>
                    <div>#Mobile App. Developer</div>
                    <div>#Web App. Developer</div>
                    <div>#Cloud & Backend Engineer</div>
                  </div>
                </div>
              )}
            </InView>
            <InView triggerOnce>
              {({ inView, ref, entry }) => (
                <div className={`${inView && AppStyle['descAnimI']}`} style={{ opacity: !inView ? '0.0' : '1.0' }} ref={ref} >
                  <div>
                    Current Interested Project
                  </div>
                  <div>
                    <div>#Web Application (React, Vue)</div>
                    <div>#Mobile Application (Cross-platform development with Flutter / React Native)</div>
                  </div>
                </div>
              )}
            </InView>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Contact